import { graphql } from '@api/gql';

export const syslogEventFragmentDocument = graphql(/* GraphQL */ `
  fragment SyslogEventFragment on SyslogEvent {
    id
    timestamp
    action
    actor {
      id
      type
      name
    }
    target {
      id
      type
      name
    }
    source
  }
`);

export const getSyslogEventsDocument = graphql(/* GraphQL */ `
  query GetSyslogEvents($pagination: NaivePaginationInput!, $filter: SyslogEventsFilterInput) {
    syslogEvents(pagination: $pagination, filter: $filter) {
      totalCount
      events {
        ...SyslogEventFragment
      }
    }
  }
`);

export const getSyslogEventDocument = graphql(/* GraphQL */ `
  query GetSyslogEvent($id: ID!) {
    syslogEvent(id: $id) {
      ...SyslogEventFragment
      previousTargetObject
      currentTargetObject
    }
  }
`);

export const syslogActionsDocument = graphql(/* GraphQL */ `
  query SyslogActions {
    syslogFilterOptions {
      actions
    }
  }
`);

export const syslogSourcesDocument = graphql(/* GraphQL */ `
  query SyslogSources {
    syslogFilterOptions {
      sources
    }
  }
`);

export const syslogActorsDocument = graphql(/* GraphQL */ `
  query SyslogActors($pagination: NaivePaginationInput!, $search: String) {
    syslogFilterOptions {
      actors(pagination: $pagination, search: $search) {
        hasMore
        data {
          id
          name
          type
        }
      }
    }
  }
`);

export const syslogTargetTypesDocument = graphql(/* GraphQL */ `
  query SyslogTargetTypes {
    syslogFilterOptions {
      targetTypes
    }
  }
`);

export const syslogTargetsDocument = graphql(`
  query GetSyslogTargets($pagination: NaivePaginationInput!, $search: String) {
    syslogFilterOptions {
      targets(pagination: $pagination, search: $search) {
        hasMore
        data {
          id
          type
          name
        }
      }
    }
  }
`);
